import * as React from "react";
export const CommentIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 21 20" {...props}>
    <path d="M10.5.5C5 .5.5 3.9.5 8.2c0 2.2 1.2 4.3 3.4 5.8v4.9l5.4-3h1.1c5.5 0 10-3.4 10-7.7S16 .5 10.5.5z" />
  </svg>
);
